import { createStore } from 'vuex'
import cart from './Modules/cart'
import { getSingleCourse } from '@/Services/api/CoursesService'
import filters from './Modules/filters'
import Auth from './Modules/AuthStore'

export default createStore({
  //namespaced: true,
  state: {
    isPaid: true,
    language: localStorage.getItem("language") || "en",
    direction: localStorage.getItem("direction") || "ltr",
    coureListLength : 0,
    paddingAdded : false,
    //course data
    courseItem: null,
    loading: false,
    error: false,
  },
  getters: {
    currentLanguage(state){
      return state.language
    },
    currentDirection(state){
      return state.direction
    },
    paddingAdded(state){
      return state.getters.paddingAdded
    },
    //Course getters
    courseItem(state) {
      return state.courseItem;
    },
    coureListLength(state){
      return state.coureListLength
    },
    isLoading(state) {
      return state.loading;
    },
    error(state) {
      return state.error;
    },
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
    },
    setDirection(state, direction) {
      state.direction = direction;
    },
     /***** Course Mutations *****/
     setCourseDetails(state, courseItem) {
      state.courseItem = courseItem;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
    setcoureListLength(state,payload){
      state.coureListLength = payload
    },
    setPaddingAdd(state,payload){
      state.paddingAdded = payload
    }
  },
  actions: {
    updateLanguage({ commit }, newLanguage) {
      commit("setLanguage", newLanguage);
    },
    updateDirection({ commit }, newDirection) {
      commit("setDirection", newDirection);
    },
    //Course Details action
    async fetchCourseDetails({ commit }, courseId , coupon) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const response = await getSingleCourse(courseId, coupon);
         // Assuming response.data contains the course details
        if (response.data) {
          commit("setCourseDetails", response.data);
        } else {
          commit("setError", true);
        }
      } catch (error) {
        commit("setError", error.message || "An unknown error occurred.");
      } finally {
        commit("setLoading", false);
      }
    },
  },
  modules: {
    cart, 
    filters,
   Auth
  },
})
